import React, { useState } from "react";
import { Button, Drawer } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { bindActionCreators } from "redux";
import { Actions } from "../../Action";
import ReviewContent from "./ReviewContent";
import ReviewContent2 from "./ReviewContent2";
import ReviewContent3 from "./ReviewContent3";
const DrawerComponent = () => {
  const dispatch = useDispatch();
  const { isDrawerOpen } = bindActionCreators(Actions, dispatch);
  const drawerState = useSelector((state) => state.drawer);
  const onClose = () => {
    isDrawerOpen(false);
  };
  // console.log(drawerState)
  return (
    <Drawer
      placement="right"
      onClose={onClose}
      open={drawerState.isOpen}
      width={"85%"}
      closeIcon={false}
    >
        {drawerState.isOpen && drawerState.action==='review' && <ReviewContent/>}
        {drawerState.isOpen && drawerState.action==='newversionreview' && <ReviewContent2/>}
        {drawerState.isOpen && drawerState.action==='threadreview' && <ReviewContent3/>}
    </Drawer>
  );
};
export default DrawerComponent;
